<footer class="bg-gray-50 pt-12 md:pt-16 pb-8 text-gray-600">
  @let info = settingStore.companyInfo();

  <div class="max-w-[1200px] mx-auto px-4">
    <!-- PC: 4컬럼 그리드 / 모바일: 스택 -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-8 pb-8 md:pb-12">
      <!-- 회사 정보 -->
      <div class="flex flex-col gap-4 col-span-1 md:col-span-1">
        <a routerLink="/" class="flex items-center gap-2">
          <img src="/logo.svg" alt="Pig Bank" class="h-8 w-auto" />
        </a>
        <div class="text-[13px] leading-relaxed space-y-1.5 text-gray-500">
          <p class="font-bold text-gray-900 text-sm mb-2">{{ info.name || '피그뱅크' }}</p>
          @if (info.ceo) {
            <p>대표자: {{ info.ceo }}</p>
          }
          @if (info.tel) {
            <p>고객센터: <a [href]="'tel:' + info.tel" class="hover:text-primary transition-colors">{{ info.tel }}</a></p>
          }
          @if (info.registrationNumber) {
            <p>사업자등록번호: {{ info.registrationNumber }}</p>
          }
          @if (info.commerceNumber) {
            <p>통신판매업신고번호: {{ info.commerceNumber }}</p>
          }
          @if (info.address) {
            <p class="pt-1 select-all">{{ info.address }}</p>
          }
        </div>
      </div>

      <!-- 서비스 -->
      <div class="flex flex-col gap-4">
        <h4 class="font-bold text-gray-900 text-lg">서비스</h4>
        <ul class="flex flex-col gap-3 text-sm">
          <li><a routerLink="/product" class="hover:text-primary transition-colors">투자 상품</a></li>
          <li><a routerLink="/shop" class="hover:text-primary transition-colors">흑돼지 쇼핑</a></li>
        </ul>
      </div>

      <!-- 이용약관 및 정책 -->
      <div class="flex flex-col gap-4">
        <h4 class="font-bold text-gray-900 text-lg">이용약관 및 정책</h4>
        <ul class="flex flex-col gap-3 text-sm">
          <li><a href="/terms/service" target="_blank" class="hover:text-primary transition-colors">이용약관</a></li>
          <li>
            <a
              href="/terms/privacy"
              target="_blank"
              class="hover:text-primary transition-colors font-bold text-gray-900"
              >개인정보처리방침</a
            >
          </li>
          <li><a href="/terms/investment" target="_blank" class="hover:text-primary transition-colors">투자약관</a></li>
          <li>
            <a href="/terms/asset" target="_blank" class="hover:text-primary transition-colors">자산정보처리방침</a>
          </li>
          <li>
            <a href="/terms/third_party" target="_blank" class="hover:text-primary transition-colors"
              >개인정보 제3자 제공 동의</a
            >
          </li>
          <li>
            <a href="/terms/marketing" target="_blank" class="hover:text-primary transition-colors">마케팅 수신 동의</a>
          </li>
        </ul>
      </div>

      <!-- 고객지원 -->
      <div class="flex flex-col gap-4">
        <h4 class="font-bold text-gray-900 text-lg">고객지원</h4>
        <ul class="flex flex-col gap-3 text-sm">
          <li><a routerLink="/customer/notice" class="hover:text-primary transition-colors">공지사항</a></li>
          <li><a routerLink="/customer/faq" class="hover:text-primary transition-colors">자주 묻는 질문</a></li>
        </ul>
        <a
          routerLink="/my-page/inquiry/form"
          class="mt-1 w-fit bg-primary hover:bg-blue-700 text-white text-sm font-bold py-2.5 px-5 rounded-lg transition-colors">
          1:1 문의하기
        </a>
      </div>
    </div>

    <!-- 하단 구분선 및 저작권 -->
    <div class="border-t border-gray-200 py-6 md:py-8 text-center">
      <p class="text-xs text-gray-500 mb-3 leading-relaxed">
        투자는 원금 손실의 위험이 있으며, 과거의 수익이 미래의 수익을 보장하지 않습니다.
        <br class="hidden md:block" />
        {{ info.name || '피그뱅크' }}는 투자 중개 플랫폼으로서 투자 상품의 원리금 상환을 보장하지 않습니다.
      </p>
      <p class="text-xs text-gray-500">© {{ currentYear }} {{ info.name || '피그뱅크' }}. All Rights Reserved.</p>
    </div>
  </div>
</footer>
